/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { UserSettings } from "../../models/user-settings";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetUserSettings$Params {}

export function getUserSettings(
  http: HttpClient,
  rootUrl: string,
  params?: GetUserSettings$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<UserSettings>> {
  const rb = new RequestBuilder(rootUrl, getUserSettings.PATH, "get");
  if (params) {
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserSettings>;
    }),
  );
}

getUserSettings.PATH = "/dashboard/user/settings";
